import { render, staticRenderFns } from "./IconChevronLeft.vue?vue&type=template&id=0534c629"
import script from "./IconChevronLeft.vue?vue&type=script&lang=ts"
export * from "./IconChevronLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports